/* tslint:disable */

import { ActionInfo } from './action-info';
import { ApplicationSharing } from './application-sharing';
import { DataEntityBreakingFields } from './data-entity-breaking-fields';
import { DataEntityDeletedFields } from './data-entity-deleted-fields';
import { DataEntityDiscussions } from './data-entity-discussions';
import { DataEntityEntryNames } from './data-entity-entry-names';
import { DataEntityExportTemplate } from './data-entity-export-template';
import { DataEntityExtensions } from './data-entity-extensions';
import { DataEntityField } from './data-entity-field';
import { DataEntityFieldSources } from './data-entity-field-sources';
import { DataEntityFromSettings } from './data-entity-from-settings';
import { DataEntityIndex } from './data-entity-index';
import { DataEntityIsImplicitOptions } from './data-entity-is-implicit-options';
import { DataEntityTreeStructureConfig } from './data-entity-tree-structure-config';
import { DataEntityVirtualOptions } from './data-entity-virtual-options';
import { DataEntityWorkflow } from './data-entity-workflow';
import { EntityDisplayTemplate } from './entity-display-template';
import { Icon } from './icon';
import { InternalCollection } from './internal-collection';
import { InternalEntity } from './internal-entity';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { StateHistory } from './state-history';
import { StoreRule } from './store-rule';
export class DataEntity {
  archiveInfo?: ActionInfo;
  breakingFields?: Array<DataEntityBreakingFields>;
  creationInfo?: ActionInfo;
  dataSources?: Array<DataEntityFieldSources>;
  deletedFields?: Array<DataEntityDeletedFields>;
  description?: null | NullableLocalizedValue;
  discussions?: DataEntityDiscussions;
  displayOption?: 0 | 1 | 2 | 3;
  displayTemplate?: EntityDisplayTemplate;
  entryNames?: null | DataEntityEntryNames;
  extentions?: DataEntityExtensions;
  fields?: Array<DataEntityField>;
  formSettings?: null | DataEntityFromSettings;
  icon: null | Icon;
  id?: string;
  implicitOptions?: DataEntityIsImplicitOptions;
  indexes?: Array<DataEntityIndex>;
  internalCollections?: Array<InternalCollection>;
  internalEntities?: Array<InternalEntity>;
  isImplicit: boolean;
  meta?: any;
  module: string;
  name: LocalizedValue;
  normalizedName: string;
  sharing?: ApplicationSharing;
  specificationVersion: number;
  state?: 0 | 1 | 2;
  stateHistory?: Array<StateHistory>;
  storeRules?: Array<StoreRule>;
  tags?: Array<string>;
  templates?: Array<DataEntityExportTemplate>;
  treeStructure?: null | DataEntityTreeStructureConfig;
  type:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 30
    | 40
    | 50
    | 51
    | 52
    | 60
    | 61
    | 70
    | 71
    | 80
    | 90
    | 72
    | 73
    | 74;
  typeOptions?: any;
  updateIdentifier: string;
  updateInfo?: ActionInfo;
  validation?: null | string;
  version?: number;
  virtual?: null | DataEntityVirtualOptions;
  workflows?: Array<DataEntityWorkflow>;
}
